import React from "react";
import Paper from "@material-ui/core/Paper";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import MessageService from "../../services/messages";
import UserService from "../../services/users";
import moment from "moment";
class MessageList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, showInactive: false, currentUser: UserService.currentUser() };
  }

  update = (ev) => {
    this.setState({ showInactive: ev.target.checked })
  }

  render() {
    let items = this.props.items.map(item => {
      const read = item.read.indexOf(this.state.currentUser._id) >= 0;
      return (
        <ListItem
          key={item._id}
          onClick={e => {
            this.props.handleClick(item);
          }}
        >
          <ListItemText primary={read ? item.title : <b>{item.title}</b>} secondary={moment(item.lastModified).format('DD-MM-YYYY HH:mm')} />
        </ListItem>
      );
    });
    return (
      <div>
        <Paper>
          <List>{items}</List>
        </Paper>
      </div>
    );
  }
}
export default MessageList;
